import { defineMessages } from '@jutro/locale';

export default defineMessages({
    uploadDocument: {
        'id': 'ml.policy.DocumentUploadComponent.Upload Document',
        'defaultMessage': 'Upload document'
    }
});